import cimg1 from '../images/popular/img-1.jpg'
import cimg2 from '../images/popular/img-2.jpg'
import cimg3 from '../images/popular/img-3.jpg'
import cimg4 from '../images/popular/img-4.jpg'
import cimg5 from '../images/popular/img-5.jpg'
import cimg6 from '../images/popular/img-6.jpg'

import cSimg1 from '../images/popular/popular-single/img-1.jpg'
import cSimg2 from '../images/popular/popular-single/img-2.jpg'
import cSimg3 from '../images/popular/popular-single/img-3.jpg'
import cSimg4 from '../images/popular/popular-single/img-4.jpg'
import cSimg5 from '../images/popular/popular-single/img-5.jpg'
import cSimg6 from '../images/popular/popular-single/img-6.jpg'

import author1 from '../images/popular/avater/img-1.jpg'
import author2 from '../images/popular/avater/img-2.jpg'
import author3 from '../images/popular/avater/img-3.jpg'


const Courses = [
   {
      Id: '1',
      cImg: cimg1,
      cSImg: cSimg1,
      author:author1,
      authortitle:'Robert Henry',
      lesson:'20',
      fee: '80',
      student:'200',
      ratting:'4.5',
      title: 'Learn WordPress & Elementor for Beginners',
      slug: 'Learn-WordPress-&-Elementor-for-Beginners',
      description: 'We are providing you the best UI/UX design guideline. That help you be professional.',
   },
   {
      Id: '2',
      cImg: cimg2,
      cSImg: cSimg2,
      author:author2,
      authortitle:'Aliza Anny',
      lesson:'30',
      fee: '100',
      student:'420',
      ratting:'5.0',
      title: 'The Complete Guide to Be a Graphics Designer.',
      slug: 'The-Complete-Guide-to-Be-a-Graphics-Designer',
      description: 'We are providing you the best Digital Marketing guideline. That help you be professional. '
   },
   {
      Id: '3',
      cImg: cimg3,
      cSImg: cSimg3,
      author:author3,
      authortitle:'David Miller',
      lesson:'25',
      fee: '90',
      student:'300',
      ratting:'4.8',
      title: 'Learning How To Write As A Professional Author',
      slug: 'Learning-How-To-Write-As-A-Professional-Author',
      description: 'We are providing you the best Development guideline. That help you be professional.'
   },
   {
      Id: '4',
      cImg: cimg4,
      cSImg: cSimg4,
      author:author1,
      authortitle:'Takla Beshu',
      lesson:'30',
      fee: '120',
      student:'730',
      ratting:'4.9',
      title: 'Learn WordPress & Elementor for Beginners',
      slug: 'Learn-WordPress-&-Elementor-for-Beginner',
      description: 'We are providing you the best Self Improvement guideline. That help you be professional.'
   },
   {
      Id: '5',
      cImg: cimg5,
      cSImg: cSimg5,
      author:author2,
      authortitle:'william taklu',
      lesson:'50',
      fee: '50',
      student:'380',
      ratting:'4.2',
      title: 'The Complete Guide to Be a Graphics Designer.',
      slug: 'The-Complete-Guide-to-Be-a-Graphics',
      description: 'We are providing you the best Video Editing guideline. That help you be professional.'
   },
   {
      Id: '6',
      cImg: cimg6,
      cSImg: cSimg6,
      author:author3,
      authortitle:'Bibi Rela',
      lesson:'70',
      fee: '50',
      student:'540',
      ratting:'4.3',
      title: 'Learning How To Write As A Professional Author',
      slug: 'Learning-How-To-Write-As-A-Professional',
      description: 'We are providing you the best Video Editing guideline. That help you be professional.'
   }

]

export default Courses;